import { IAutoMapper } from "../../../../../core/automapper/interfaces";

export const mapMatchingChase = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "MatchingChase")
    .forMember("chaseId", o => o.chaseId)
    .forMember("invoiceId", o => o.invoiceId)
    .forMember("chaseAmount", o => o.chaseAmount);
};

export class MatchingChase {
  chaseId: number;
  invoiceId: number;
  chaseAmount: number;

  constructor(options: { chaseId?: number; invoiceId?: number; chaseAmount?: number }) {
    this.chaseId = options.chaseId;
    this.invoiceId = options.invoiceId;
    this.chaseAmount = options.chaseAmount;
  }
}
